import { createSlice } from "@reduxjs/toolkit";
import { DonetionInitialLoad, DonetionPaggination } from "../thunk/DonetionThunk";

const initialState = {
    donetions: [],
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export const DonetionSlice = createSlice({
    name: "donetions",
    initialState,
    reducers: {
        resetDonetion: (state, action) => {
            return {
                ...initialState
            };

        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(DonetionInitialLoad.pending, (state, action) => {
                return { ...state, showLoading: true };
            })
            .addCase(DonetionInitialLoad.fulfilled, (state, action) => {

                return {
                    ...state,
                    donetions: action.payload,
                    errorMessage: '',
                    successMessage: '',
                    showLoading: false,
                };
            })
            .addCase(DonetionInitialLoad.rejected, (state, action) => {
                let errorMessage;
                if (action.payload) {
                    // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                    errorMessage = action.payload;
                } else {
                    errorMessage = action.error.message?.toString();
                }

                return { ...state, errorMessage, showLoading: false }
            })
            .addCase(DonetionPaggination.pending, (state, action) => {
                return { ...state, showLoading: true };
            })
            .addCase(DonetionPaggination.fulfilled, (state, action) => {

                // console.log({ action });

                return {
                    ...state,
                    donetions: action.payload,
                    errorMessage: '',
                    successMessage: '',
                    showLoading: false,
                };
            })
            .addCase(DonetionPaggination.rejected, (state, action) => {
                let errorMessage;
                if (action.payload) {
                    // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                    errorMessage = action.payload;
                } else {
                    errorMessage = action.error.message?.toString();
                }
                return { ...state, errorMessage, showLoading: false }
            });
    },
});


export const { resetDonetion } = DonetionSlice.actions;

export const DonetionReducer = DonetionSlice.reducer;